import { render } from "./faturaFornecedor.vue?vue&type=template&id=575b0f60&scoped=true"
import script from "./faturaFornecedor.vue?vue&type=script&lang=js"
export * from "./faturaFornecedor.vue?vue&type=script&lang=js"

import "./faturaFornecedor.vue?vue&type=style&index=0&id=575b0f60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575b0f60"]])

export default __exports__